import { render, staticRenderFns } from "./frontDetalleContainer.vue?vue&type=template&id=2fc5389c&"
import script from "./frontDetalleContainer.vue?vue&type=script&lang=js&"
export * from "./frontDetalleContainer.vue?vue&type=script&lang=js&"
import style0 from "./frontDetalleContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports